import React from "react";
import MultipleSelect from "features/Admin/components/NewMultipleSelect";

const QuestionsFormOrder = ({ questionsFactory, updateQuestions }) => (
	<div>
		<MultipleSelect update={updateQuestions} order factory={questionsFactory} />
	</div>
);

export default QuestionsFormOrder;
